/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { IVisitor } from '../visitors/IVisitor';

/**
 * All visitable data model classes must implement this interface.
 * @author eric.wittmann@gmail.com
 * @class
 */
export interface IVisitable {
    /**
     * Called to accept a visitor onto a visitable data model instance.
     * @param {*} visitor
     */
    accept(visitor : IVisitor);
}


